export function stickyHero() {
    const _document = this._document;
    const wrapper = _document.querySelector(".wrapper");
    const header = wrapper.querySelector(".main-header");
    const main = wrapper.querySelector("main");
    const heroSection = wrapper.querySelector(".hero-section.fixed");
    let mainPadding = this._window.innerWidth < 1600 ? 100 : 130;

    if(!this.isTouch) {
        wrapper.style.paddingTop = heroSection.clientHeight + "px";
        // header.classList.add("sticky");
        main.style.paddingTop = mainPadding + "px";
    }

};


// WEBPACK FOOTER //
// ./assets/js/modules/sticky-hero.js